export default __webpack_public_path__ + "static/media/mobile-commerce-effect-sales.94383cd3.png";